import React, { useEffect, useState } from 'react';
import '../landing.css';

const FEED = [
  { tag: 'INCOMING', title: 'Incoming signal', body: 'The trader is about to open a position. Get ready.' },
  { tag: 'ENTERED', title: 'SOL LONG entered', body: 'Entry 182.40 · Leverage 16x · TP1, TP2, TP3 set · Stop loss set' },
  { tag: 'TP1 HIT', title: 'TP1 hit, profit banked', body: '33% of the position closed automatically.' },
  { tag: 'PROTECTED', title: 'Stop loss moved halfway', body: 'The rest of the trade keeps running with less risk.' }
];

const STEPS = [
  { n: '01', title: 'Our trader posts a signal', body: 'A professional trader calls every setup: coin, direction, entry, three take profits and a stop loss.' },
  { n: '02', title: 'The bot enters for you', body: 'Within seconds the bot opens the same trade on your own BloFin account, sized to your settings.' },
  { n: '03', title: 'Profits and protection are set', body: 'Take profits and your stop loss are placed automatically. TPs close portions of the trade as they hit.' },
  { n: '04', title: 'You get a ping on Telegram', body: 'Every entry, take profit and stop loss move is confirmed on Telegram, so you always know what is happening.' }
];

const BENEFITS = [
  { icon: 'moon', title: 'Never miss a trade', body: 'Asleep, at work, on a plane. Signals come at any hour and the bot takes them for you.' },
  { icon: 'bolt', title: 'Executes in seconds', body: 'No fumbling with orders. The bot is in the trade while most people are still opening the app.' },
  { icon: 'lock', title: 'Your money stays yours', body: 'Funds sit in your own BloFin account. The bot can trade, but it can never withdraw or transfer.' },
  { icon: 'shield', title: 'Protection built in', body: 'Every trade has a stop loss. Moving Stop Loss and Liquidation Protection add extra layers.' },
  { icon: 'chat', title: 'Runs from Telegram', body: 'Set up, change settings, check your balance and positions, or pause, all from one chat.' },
  { icon: 'user', title: 'A real trader behind it', body: 'Signals come from our lead trader, plus a VIP group with market updates and daily results.' }
];

const PROFILES = {
  Conservative: {
    blurb: 'Bank profits early and keep risk tight.',
    rows: [
      ['Position size', '1% per trade'],
      ['Leverage', "Copy the trader's"],
      ['Liquidation Protection', 'On'],
      ['Take profit split', '75 / 12.5 / 12.5'],
      ['Moving stop loss', 'To entry after TP1'],
      ['Risk filter', 'Low risk trades only']
    ]
  },
  Balanced: {
    blurb: 'An even spread that suits most markets.',
    rows: [
      ['Position size', '2% per trade'],
      ['Leverage', "Copy the trader's"],
      ['Liquidation Protection', 'On'],
      ['Take profit split', '33 / 33 / 34'],
      ['Moving stop loss', 'Halfway after TP1'],
      ['Risk filter', 'All trades']
    ]
  },
  Aggressive: {
    blurb: 'Lean into the big targets when the trend is clear.',
    rows: [
      ['Position size', 'Low 4% · Med 2% · High 1%'],
      ['Leverage', "Copy the trader's"],
      ['Liquidation Protection', 'Off'],
      ['Take profit split', '25 / 25 / 50'],
      ['Moving stop loss', 'Halfway after TP1'],
      ['Risk filter', 'All trades']
    ]
  }
};

const CONTROLS = [
  { title: 'Position size', body: 'A % of your balance, a custom %, or a fixed dollar amount per trade.' },
  { title: 'Size by risk level', body: 'Different sizes for Low, Medium and High risk signals, applied automatically.' },
  { title: 'Leverage', body: "Copy the trader's leverage, or set your own fixed or custom value." },
  { title: 'Liquidation Protection', body: 'Lowers leverage when needed so your stop loss hits before liquidation.' },
  { title: 'Margin mode', body: 'Isolated, so each trade stands alone, or Cross, backed by your whole wallet.' },
  { title: 'Take profit strategy', body: 'TP1, TP2, TP3 or any mix, with your own split across all three.' },
  { title: 'Moving stop loss', body: 'After TP1, move your stop to entry or halfway. Or leave it where it is.' },
  { title: 'Risk filter', body: 'Trade Low risk only, Low and Medium, or every signal.' }
];

function Icon({ name }) {
  const p = { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (name) {
    case 'moon': return <svg {...p}><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></svg>;
    case 'bolt': return <svg {...p}><path d="M13 2 3 14h9l-1 8 10-12h-9l1-8z" /></svg>;
    case 'lock': return <svg {...p}><rect x="4" y="11" width="16" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>;
    case 'shield': return <svg {...p}><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="m9 12 2 2 4-4" /></svg>;
    case 'chat': return <svg {...p}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>;
    default: return <svg {...p}><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>;
  }
}

function SignalFeed() {
  const [shown, setShown] = useState(1);
  useEffect(() => {
    const t = setInterval(() => setShown(s => (s >= FEED.length ? 1 : s + 1)), 1800);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="lp-phone">
      <div className="lp-phone-head">
        <div className="lp-phone-avatar"><img src="/brand.jpg" alt="" /></div>
        <div>
          <div className="lp-phone-name">HeilpernFuturesAI</div>
          <div className="lp-phone-status"><span className="lp-dot" /> online</div>
        </div>
      </div>
      <div className="lp-phone-body">
        {FEED.slice(0, shown).map((m, i) => (
          <div className="lp-msg" key={`${m.tag}-${i}`}>
            <span className={`lp-msg-tag t${i}`}>{m.tag}</span>
            <div className="lp-msg-title">{m.title}</div>
            <div className="lp-msg-body">{m.body}</div>
          </div>
        ))}
      </div>
      <div className="lp-phone-foot">Example notifications</div>
    </div>
  );
}

export default function Landing({ onApply }) {
  const [profile, setProfile] = useState('Balanced');

  useEffect(() => {
    const els = document.querySelectorAll('.lp-reveal');
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);

  const scrollTo = id => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <div className="lp">
      <header className="lp-nav">
        <div className="lp-nav-brand">
          <span className="lp-nav-mark"><img src="/brand.jpg" alt="" /></span>
          <span>Heilpern Futures AI</span>
        </div>
        <button className="btn-primary lp-nav-cta" onClick={onApply}><span>Apply now</span></button>
      </header>

      <section className="lp-hero">
        <div className="lp-hero-copy">
          <div className="lp-eyebrow"><span className="lp-dot" /> Live on BloFin · Runs on Telegram</div>
          <h1 className="lp-h1">AI Trading <span className="lp-grad">Bot</span></h1>
          <p className="lp-tagline">Trading, done for you.</p>
          <p className="lp-sub">Fully customisable to your own risk appetite and trading style. A professional trader calls the trades, the bot places them on your account in seconds, and you stay in control of every setting.</p>
          <div className="lp-cta-row">
            <button className="btn-primary lp-cta" onClick={onApply}><span>Apply now</span></button>
            <button className="btn-ghost lp-cta-ghost" onClick={() => scrollTo('how')}>See how it works</button>
          </div>
          <div className="lp-trust">
            <span>No withdrawal access</span>
            <span>Your own account</span>
            <span>Pause anytime</span>
          </div>
        </div>
        <div className="lp-hero-visual">
          <div className="lp-orb" />
          <SignalFeed />
        </div>
      </section>

      <section className="lp-stats lp-reveal">
        <div><strong>Seconds</strong><span>from signal to entry</span></div>
        <div><strong>24/7</strong><span>never misses a signal</span></div>
        <div><strong>3</strong><span>take profit levels per trade</span></div>
        <div><strong>0</strong><span>access to withdraw your funds</span></div>
      </section>

      <section className="lp-section" id="how">
        <div className="lp-head lp-reveal">
          <div className="lp-kicker">How it works</div>
          <h2>From signal to profit, on autopilot.</h2>
          <p>You connect your BloFin account once. After that, every trade our trader takes is copied to your account automatically.</p>
        </div>
        <div className="lp-steps">
          {STEPS.map(s => (
            <div className="lp-step lp-reveal" key={s.n}>
              <div className="lp-step-n">{s.n}</div>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="lp-section">
        <div className="lp-head lp-reveal">
          <div className="lp-kicker">Why members use it</div>
          <h2>The trader does the analysis. The bot does the clicking.</h2>
        </div>
        <div className="lp-grid3">
          {BENEFITS.map(b => (
            <div className="lp-card lp-reveal" key={b.title}>
              <div className="lp-icon"><Icon name={b.icon} /></div>
              <h3>{b.title}</h3>
              <p>{b.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="lp-section">
        <div className="lp-head lp-reveal">
          <div className="lp-kicker">Your rules</div>
          <h2>Built around your risk appetite.</h2>
          <p>No two traders are the same. Pick a style below to see how the bot can be set up, then make it your own.</p>
        </div>
        <div className="lp-profile lp-reveal">
          <div className="lp-tabs" role="tablist">
            {Object.keys(PROFILES).map(k => (
              <button key={k} role="tab" aria-selected={profile === k} className={`lp-tab ${profile === k ? 'on' : ''}`} onClick={() => setProfile(k)}>{k}</button>
            ))}
          </div>
          <p className="lp-profile-blurb">{PROFILES[profile].blurb}</p>
          <div className="lp-profile-rows" key={profile}>
            {PROFILES[profile].rows.map(([k, v]) => (
              <div className="lp-row" key={k}><span>{k}</span><strong>{v}</strong></div>
            ))}
          </div>
          <p className="lp-note">Examples only. Every setting can be changed anytime from the bot's menu.</p>
        </div>
        <div className="lp-controls">
          {CONTROLS.map(c => (
            <div className="lp-control lp-reveal" key={c.title}>
              <h4>{c.title}</h4>
              <p>{c.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="lp-section">
        <div className="lp-secure lp-reveal">
          <div className="lp-secure-icon"><Icon name="lock" /></div>
          <div>
            <div className="lp-kicker">Security first</div>
            <h2>Your money never leaves your account.</h2>
            <p>The bot connects to your own BloFin account with a key that can only read and trade. Withdrawals and transfers stay switched off, and the key is locked to our secure server. Even in the worst case, nothing can be moved out of your account.</p>
          </div>
        </div>
      </section>

      <section className="lp-section">
        <div className="lp-head lp-reveal">
          <div className="lp-kicker">You stay in control</div>
          <h2>Done for you, not out of your hands.</h2>
          <p>The bot handles execution. You decide the risk. The members who do best keep an eye on the trader's updates in the VIP group and adjust their settings as the market changes. Pause or stop the bot whenever you like.</p>
        </div>
        <div className="lp-needs lp-reveal">
          <div><strong>What you need</strong></div>
          <span>A BloFin account through our link</span>
          <span>Telegram on your phone</span>
          <span>USDT in your futures account</span>
        </div>
      </section>

      <section className="lp-final lp-reveal">
        <h2>Ready to let the bot trade for you?</h2>
        <p>Answer a few quick questions. Our team will reach out on Telegram to see if it is the right fit.</p>
        <button className="btn-primary lp-cta" onClick={onApply}><span>Start your application</span></button>
        <div className="lp-time">Takes about 60 seconds</div>
      </section>

      <footer className="lp-foot">
        <p>Trading futures carries a high level of risk and you can lose money. Past results do not guarantee future returns. Nothing on this page is financial advice.</p>
        <p>© Layah Heilpern · Elite Edge Crypto</p>
      </footer>
    </div>
  );
}
